export default __webpack_public_path__ + "static/media/Screenshot (1067).722f912b.png";